<template>
  <div class="acceptance-page">
    <div class="page-header">
      <div class="pull-left text-xl">
        <span class="pull-left">Настройка приемки вызова</span>
      </div>
    </div>

    <CustomTabs
      class="acceptance-page__tabs"
      :data="tabs"
      :tab="tab"
      @change_tab="onTabChange"
    />

    <AcceptanceRules v-if="tab === 'acceptance'" class="acceptance-page__tab-pane" />
    <AcceptanceSteps v-if="tab === 'steps'" class="acceptance-page__tab-pane" />
  </div>
</template>

<script>
import CustomTabs from "@/components/common/CustomTabs";
import AcceptanceRules from "./AcceptanceRules";
import AcceptanceSteps from "./AcceptanceSteps";
 
export default {
  name: "Acceptance",
  components: {
    CustomTabs,
    AcceptanceRules,
    AcceptanceSteps,
  },
  data() {
    return {
      tab: this.$route.query.tab || "acceptance",
      tabs: [
        { name: "acceptance", label: "Приёмка" },
        { name: "steps", label: "Шаги приёмки" },
      ],
    };
  },
  watch: {
    "$route.query.tab": {
      immediate: true,
      handler(newTab) {
        if (newTab) {
          this.tab = newTab;
        }
      },
    },
  },
  methods: {
    onTabChange(newTab) {
      this.tab = newTab;
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: newTab,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.acceptance-page {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: auto;
}

.acceptance-page__tabs {
  flex-shrink: 0;
}

.acceptance-page__tab-pane {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page-header {
  margin-bottom: 15px;
  .pull-left {
    display: inline-block;
    vertical-align: middle;
    font-size: 32px;
  }
}
</style>
